import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { SelectField } from 'Components';
import pagesizes from 'constants/pageSizes';
import './ResultsPerPage.css';

const ResultsPerPage = ({
  pageSize,
  onChange,
}) => (
  <div className="results-per-page">
    <SelectField
      options={pagesizes.map(value => ({
        value: String(value),
        label: `${value} ${i18n.t('common:Results per page')}`,
      }))}
      value={pageSize}
      onChange={onChange}
    />
  </div>
);

ResultsPerPage.propTypes = {
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
};

export default ResultsPerPage;



// WEBPACK FOOTER //
// ./src/components/Actions/ResultsPerPage/ResultsPerPage.jsx